import env from './env';

const GTBTY_PATH = '/gtb-thank-you/shipping';

function redirectToEdit() {
  window.location.assign(`https://${env.originUrl}/edit`);
}

function redirectToGtb() {
  window.location.assign(`https://${env.originUrl}/get-the-box`);
}

function redirectToShippingAddress() {
  window.location.assign(GTBTY_PATH);
}

export {
  redirectToEdit,
  redirectToGtb,
  redirectToShippingAddress,
};
